"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var mediaQuery_1 = require("../systems/mediaQuery");

var display_1 = require("../systems/display");

var textAlign_1 = require("../systems/textAlign"); // Could support global css properties, but doesn't for now


exports.fontSizeSystem = function (props) {
  if (props === void 0) {
    props = {};
  }

  var styles = {};

  if (props.size) {
    // Against 12px
    styles['font-size'] = parseInt(props.size + '', 10) + "rem";
  }

  if (props.sizePx) {
    styles['font-size'] = parseInt(props.sizePx + '', 10) + "px";
  }

  if (props.sizeEm) {
    styles['font-size'] = parseInt(props.sizeEm + '', 10) + "em";
  }

  return styles;
};

var BasicType = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), function (props) {
  return __assign({}, display_1.default(props), textAlign_1.default(props), exports.fontSizeSystem(props));
}, function (props) {
  return mediaQuery_1.default(props, [display_1.default, textAlign_1.default, exports.fontSizeSystem]);
});
exports.default = BasicType;
var templateObject_1;